import { lightTheme } from "./themes/light";

export {
  ThemeCssVariables,
  ThemeProvider,
  ThemeProviderConnected,
  ThemeContext,
} from "./ThemeProvider";
export { useTheme } from "./useTheme";
export { lightTheme } from "./themes/light";
export { darkTheme } from "./themes/dark";
export type { ThemeContextValue, ThemeProviderProps } from "./ThemeProvider";
export type { AppTheme, Palette, ThemeMode } from "./tokens";

export { lightTheme as Theme };
export const ThemePalette = lightTheme.palette;
